import get from 'lodash/get';

import { getTeamOrUserName } from './ui/getTaemOrUserName';
import { TODO_ASSIGNMENT_TITLE as ASSIGNMENT_TITLES } from '../constants/strings';

const methods = Object.keys(ASSIGNMENT_TITLES);

export default (todo, formatMessage) => {
  const { assignmentMethod, assignerName, assigner, originalAssigner } = todo;
  const { lastName, firstName, namePrefix, nameSuffix, credential } =
    assigner || {};
  const method = (assignmentMethod || '').toLowerCase();

  const name = (
    assignerName ||
    [namePrefix, firstName, lastName, nameSuffix, credential].join(' ') ||
    ''
  ).trim();

  const originalAssignerName = get(originalAssigner, 'displayableName');
  const fullAssignerName = getTeamOrUserName(name, originalAssignerName);

  const task = formatMessage({ id: 'task.assigned' });
  const assignment = methods.includes(method)
    ? `, ${formatMessage(ASSIGNMENT_TITLES[method], {
        name: fullAssignerName,
      })}`
    : '';

  return task + assignment;
};



// WEBPACK FOOTER //
// ./src/utils/getToDoAssigmentText.js